import { type FC } from "react";

import { faFileLines } from "@fortawesome/pro-duotone-svg-icons/faFileLines";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Badge } from "@styled/badge";
import { BasicLink } from "@styled/basic_link";

import { type PushableOrganization } from "./pushable_organization";

export const summaryFormatPath = (id: string) =>
  `/dashboard/organizations/${id}/summary-format`;

// "Custom format" on an org whose Summary files differ from the base, so
// nobody is surprised; it opens the format.
export const OrganizationCustomFormatBadge: FC<{
  organization: Pick<PushableOrganization, "id" | "summaryFormat">;
}> = ({ organization }) =>
  organization.summaryFormat.custom ? (
    <BasicLink to={summaryFormatPath(organization.id)}>
      <Badge pill variant="outlined" color="indigo">
        <FontAwesomeIcon icon={faFileLines} /> Custom format
      </Badge>
    </BasicLink>
  ) : null;
